import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { getTransactionReceiptAction } from './transaction-receipt.actions';
import { ITransactionReceiptFeature } from './transaction-receipt.feature.state';
import { getIsLoading, getTransactionReceipt } from './transaction-receipt.selectors';

@Injectable()
export class TransactionReceiptFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public transactionReceipt$ = this.store.select(getTransactionReceipt).pipe(filter((transactionReceipt) => transactionReceipt !== null));

  constructor(private store: Store<ITransactionReceiptFeature>) {}

  public getTransactionReceipt(seq: number): void {
    this.store.dispatch(getTransactionReceiptAction({ seq }));
  }
}
